import { BaseApi } from './base.api.js';

export class CommunicationChannelApi extends BaseApi {
    constructor(client, basePath = '/communication-channels') {
        super(client, basePath);
    }
}
